import { render, staticRenderFns } from "./Projects.vue?vue&type=template&id=1f5f3b4d&scoped=true&"
import script from "./Projects.vue?vue&type=script&lang=js&"
export * from "./Projects.vue?vue&type=script&lang=js&"
import style0 from "./Projects.vue?vue&type=style&index=0&id=1f5f3b4d&scoped=true&lang=css&"
import style1 from "./Projects.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5f3b4d",
  null
  
)

component.options.__file = "Projects.vue"
export default component.exports